// All timestamps in the app are stored as UTC in MongoDB.
// Greece uses Europe/Athens (UTC+2 in winter, UTC+3 in summer / DST).
// Pinning every display function to this timezone ensures the app
// always shows Greek local time, regardless of the visitor's browser timezone.
const GREEK_TZ = 'Europe/Athens';

export const formatEuropeanDate = (value) => {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split('-');
      return `${day}-${month}-${year}`;
    }
    return value;
  }
  return date.toLocaleDateString('en-GB', { timeZone: GREEK_TZ }).replace(/\//g, '-');
};

export const formatEuropeanDateTime = (value) => {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const datePart = date.toLocaleDateString('en-GB', { timeZone: GREEK_TZ }).replace(/\//g, '-');
  const timePart = date.toLocaleTimeString('en-GB', { timeZone: GREEK_TZ, hour: '2-digit', minute: '2-digit' });
  return `${datePart} ${timePart}`;
};

// Returns HH:mm in Greek time — used for compact time labels.
export const formatEuropeanTime = (value) => {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString('en-GB', { timeZone: GREEK_TZ, hour: '2-digit', minute: '2-digit' });
};

// Returns YYYY-MM-DD string in Greek time — used for date-picker input values.
export const toInputDateValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  // en-CA locale produces YYYY-MM-DD, which is what <input type="date"> expects.
  return date.toLocaleDateString('en-CA', { timeZone: GREEK_TZ });
};